'use strict';

angular.module('schoolLinqApp').controller('vendorHistoryController', [
	'$scope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'vendorService',
	'utilsService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
	function ($scope, $q, $interval, dialogHelper, reportHelper, vendorService, utilsService, USER_CLAIMS, BUSY_MESSAGE) {
		var viewModel = getViewModel();
		$scope.vm = viewModel;

		$scope.reportInterval = null;
		$scope.isReportFinished = false;

		$scope.loadingPromise = $q.all([$scope.vm.loadVendors($scope.vm), $scope.vm.loadJournalCodes($scope.vm)]);

		$scope.barLimit = 4;
		$scope.startIndex = 0;
		$scope.account = null;

		function getViewModel() {
			var model = {
				message: BUSY_MESSAGE.Loading,
				journalCodesCheckAll: false,
				journalCodes: [],
				journalCodesLeft: [],
				journalCodesRight: [],
				claimSections: USER_CLAIMS,
				filter: {
					dateFrom: moment().toDate(),
					dateTo: moment().toDate(),
					vendors: [],
					selectedVendor: {},
					sortById: '0',
					journalCodesSelected: [],
					reportParameters: [],
				},
				validationErrors: [],
				errors: null,
			};

			function validateReportParams(model) {
				model.validationErrors = [];
				let isValid = true;

				if (!model.filter.dateFrom) {
					model.validationErrors.push("Please select a 'From' date.");
					isValid = false;
				}

				if (!model.filter.dateTo) {
					model.validationErrors.push("Please select a 'To' date.");
					isValid = false;
				}

				if (isValid == true && moment(model.filter.dateFrom).startOf('day') > moment(model.filter.dateTo).startOf('day')) {
					model.validationErrors.push('Date Range is invalid!');
					isValid = false;
				}

				var selectCount = 0;
				angular.forEach(model.journalCodesLeft, function (jc) {
					if (jc.Selected) {
						selectCount++;
					}
				});
				angular.forEach(model.journalCodesRight, function (jc) {
					if (jc.Selected) {
						selectCount++;
					}
				});

				if (selectCount == 0) {
					model.validationErrors.push('Please select one or more Journal Codes to proceed.');
					isValid = false;
				}

				return isValid;
			}

			function openVendorHistory(model) {
				if (!validateReportParams(model)) {
					dialogHelper.openMessageBox('Vendor History Report Error!', null, model.validationErrors);
					return false;
				}

				$scope.isReportFinished = false;
				model.message = BUSY_MESSAGE.GeneratingReport;
				$scope.loadingPromise = $scope.reportInterval = $interval(function () {
					if ($scope.isReportFinished) {
						$interval.cancel($scope.reportInterval);
						$scope.isReportFinished = false;
					}
				}, 1000);

				// get selected journal codes
				model.filter.journalCodesSelected = [];
				angular.forEach(model.journalCodesLeft, function (jc) {
					if (jc.Selected) {
						model.filter.journalCodesSelected.push(jc.Code);
					}
				});
				angular.forEach(model.journalCodesRight, function (jc) {
					if (jc.Selected) {
						model.filter.journalCodesSelected.push(jc.Code);
					}
				});

				var report = {
					dateFrom: moment(model.filter.dateFrom).format('l'),
					dateTo: moment(model.filter.dateTo).format('l'),
					vendorId: parseInt(model.filter.selectedVendor.Id) || 0,
					sortById: parseInt(model.filter.sortById) || 0,
					JournalCodesCol: model.filter.journalCodesSelected,
				};

				reportHelper.getReport($scope, '/api/fundreports/vendorhistoryreport', report, 'VendorHistoryReport.pdf');
			}

			function exportExcel(model) {
				if (!validateReportParams(model)) {
					dialogHelper.openMessageBox('Vendor History Export Error!', null, model.validationErrors);
					return false;
				}

				$scope.isReportFinished = false;
				model.message = BUSY_MESSAGE.GeneratingExcelFile;
				$scope.loadingPromise = $scope.reportInterval = $interval(function () {
					if ($scope.isReportFinished) {
						$interval.cancel($scope.reportInterval);
						$scope.isReportFinished = false;
					}
				}, 1000);

				// get selected journal codes
				model.filter.journalCodesSelected = [];
				angular.forEach(model.journalCodesLeft, function (jc) {
					if (jc.Selected) {
						model.filter.journalCodesSelected.push(jc.Code);
					}
				});
				angular.forEach(model.journalCodesRight, function (jc) {
					if (jc.Selected) {
						model.filter.journalCodesSelected.push(jc.Code);
					}
				});

				var report = {
					dateFrom: moment(model.filter.dateFrom).format('l'),
					dateTo: moment(model.filter.dateTo).format('l'),
					vendorId: parseInt(model.filter.selectedVendor.Id) || 0,
					sortById: parseInt(model.filter.sortById) || 0,
					JournalCodesCol: model.filter.journalCodesSelected,
				};

				reportHelper.getExcel($scope, '/api/fundreports/vendorhistoryexcel', report, 'VendorHistory.xlsx');
			}

			function loadVendors(model) {
				return vendorService.getVendors().then(_.partial(finishLoadingVendors, model));

				function finishLoadingVendors(model, response) {
					model.filter.vendors = response.data.vendors;
					model.filter.vendors.splice(0, 0, { VendorName: 'All Vendors', Id: 0 });
					model.filter.selectedVendor = model.filter.vendors[0];

					return angular.noop;
				}
			}

			function loadJournalCodes(model) {
				return utilsService.getjournalCodes().then(_.partial(finishLoadingJournalCodes, model));

				function finishLoadingJournalCodes(model, response) {
					model.journalCodes = response.data.codes;

					var arrTemp = ['AP', 'CD', 'PR'];

					//var objType = _.find(model.accountTypes, function (obj) { return obj.Id == parseInt(model.filter.accountTypeId) });

					//build left list
					var idx = 1;
					angular.forEach(arrTemp, function (jc) {
						var obj1 = _.find(model.journalCodes, function (obj) {
							return obj.Code === jc;
						});
						var objJC = {
							Id: obj1.Id,
							Code: obj1.Code,
							Description: obj1.Description,
							Selected: false,
						};

						if (idx <= 2) {
							model.journalCodesLeft.push(objJC);
						} else {
							model.journalCodesRight.push(objJC);
						}

						idx++;
					});
				}
			}

			function journalCodeChange(model) {
				var codeCount = model.journalCodesLeft.length + model.journalCodesRight.length;
				var idx = 0;
				angular.forEach(model.journalCodesLeft, function (jc) {
					if (jc.Selected) {
						idx++;
					}
				});
				angular.forEach(model.journalCodesRight, function (jc) {
					if (jc.Selected) {
						idx++;
					}
				});

				model.journalCodesCheckAll = codeCount === idx;
			}

			function journalCodesCheckAllChange(model) {
				angular.forEach(model.journalCodesLeft, function (jc) {
					jc.Selected = model.journalCodesCheckAll;
				});
				angular.forEach(model.journalCodesRight, function (jc) {
					jc.Selected = model.journalCodesCheckAll;
				});
			}

			return angular.extend(model, {
				loadVendors: _.partial(loadVendors, model),
				openVendorHistory: _.partial(openVendorHistory, model),
				exportExcel: _.partial(exportExcel, model),
				loadJournalCodes: _.partial(loadJournalCodes, model),
				journalCodeChange: _.partial(journalCodeChange, model),
				journalCodesCheckAllChange: _.partial(journalCodesCheckAllChange, model),
			});
		}
	},
]);
